// Canonical image-width ladder.
//
// *** SYNC CONTRACT ***  This file MUST stay byte-identical in travelfeed-io
// and tf-static-blog-tailwind, and it is the frontend half of the dimension
// rounding the img.truvvle.com Cloudflare Worker does in cfworker.js. Both
// repos resize every image through the same proxy into the same Backblaze/R2
// derivative store, which is keyed on (source, width, height). Each distinct
// width is therefore a separate stored object AND a separate cold imgproxy
// resize (slow vs. an R2 cache hit). The whole point of this ladder is that
// every surface in both apps requests the SAME handful of widths, so the same
// source image resolves to ONE derivative no matter where it is shown. If you
// change the ladder, change it in BOTH repos in the same change (and ideally
// bump cfworker.js to match) or the cache re-fragments.
//
// We request WIDTH ONLY and let CSS object-cover frame each box (cards, thumbs,
// heroes). A given image at a given width is therefore one proportional
// derivative shared across every surface — we deliberately do NOT crop to a
// fixed card aspect server-side, which would spawn a second derivative family
// per cover on top of the proportional one and shift the crop off-center.

// Content / cover widths. Multiples of 100 so the Worker's round-up-to-100 is
// a no-op and requests land on exactly these derivatives. Covers phone DPR
// 1-3 (400 / 800 / 1200), tablet & retina-laptop body (1600) and the retina
// hero (2000).
const CONTENT_WIDTHS = [400, 800, 1200, 1600, 2000];

// Small square slots for avatars / thumbnails (1:1).
const SQUARE_WIDTHS = [96, 200];

// Full snap ladder, ascending.
const CANONICAL_WIDTHS = [...SQUARE_WIDTHS, ...CONTENT_WIDTHS];

// Snap a requested pixel dimension to the NEAREST canonical step (ties round
// up, so we never meaningfully under-resolve). Nearest — not round-up — so a
// stray 1210 collapses onto 1200 instead of jumping to a fresh 1600 derivative.
// Missing or non-numeric input passes through untouched so callers that omit a
// dimension (e.g. proportional, height-less requests) keep working.
const snapWidth = value => {
  if (value === undefined || value === null || value === '') return value;
  const n = parseInt(value, 10);
  if (!Number.isFinite(n) || n <= 0) return value;
  let best = CANONICAL_WIDTHS[0];
  for (let i = 1; i < CANONICAL_WIDTHS.length; i += 1) {
    const step = CANONICAL_WIDTHS[i];
    if (Math.abs(step - n) <= Math.abs(best - n)) best = step;
  }
  return best;
};

module.exports = {
  CONTENT_WIDTHS,
  SQUARE_WIDTHS,
  CANONICAL_WIDTHS,
  snapWidth,
};
